import { toast } from "sonner";
import { Sentry } from "@/lib/sentry";
import { ApiError, getLocalUserFacingApiMessage, getUserFacingApiMessage } from "@/lib/api-client";

/**
 * Toast a tenant-safe script-review error. Client-side validation errors (plain
 * Error, not ApiError) keep their message; API/worker failures use generic copy.
 * Readiness 409 responses stay precise — the server message is intentional UX.
 * Pass `format` (e.g. `passThroughMessage`) on operator-only actions to surface
 * the server's 4xx message; 5xx and auth errors stay generic regardless.
 */
export function toastScriptReviewError(
  error: unknown,
  format?: (message: string) => string,
): void {
  Sentry.captureException(error);
  if (error instanceof ApiError && error.status === 409) {
    toast.error(error.message);
    return;
  }
  if (error instanceof ApiError) {
    const message = getLocalUserFacingApiMessage(error, format);
    if (message) toast.error(message);
    return;
  }
  if (error instanceof Error) {
    toast.error(error.message);
    return;
  }
  toast.error(getUserFacingApiMessage(error));
}
